export const modalStyles = {
  body: {
    padding: "0px",
    minHeight: "0",
    position: "relative",
    overflow: "hidden",
  },
};
